export default "__VITE_ASSET__fe54423d__"